import CustButton from "./CustButton";

const CardServices = ({ item }) => {
  const { service_id, service_name, service_url, icon_url } = item;

  return (
    <>
      <div className="col d-flex align-items-center py-2 justify-content-center">
        <div className="bg-white rounded w-100 h-100 px-3 pb-3 pt-4 d-flex row-gap-3 flex-column justify-content-between">
          {service_id !== 12 && (
            <img src={icon_url} className="icon-service" alt="icon" />
          )}
          <div className="d-flex align-items-start h-50 name-service">
            <p className="text-start fw-semibold">{service_name}</p>
          </div>
          <div className="d-flex justify-content-center w-100">
            <CustButton text="Order Sekarang" path={service_url} />
          </div>
        </div>
      </div>
      {service_id === 11 && (
        <div className="col d-flex align-items-center py-2 justify-content-center">
          <div className="bg-white rounded w-100 h-100 px-3 pb-3 pt-4 d-flex row-gap-3 flex-column justify-content-between">
            <div className="d-flex align-items-start h-50 name-service">
              <h3 className="text-start fw-semibold">Share your ideas with us</h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardServices;
